import { UTILS } from '../functions/utils';

export function StoreModelType(
  type: () => new (...args: any[]) => any,
  discriminator?: string,
) {
  return function (target: any, key: any) {
    const typeInstance = type();

    if (!typeInstance) {
      console.warn(
        `StoreModelType: Unable to determine type for ${key.name}. Type might not exist or is declared after the class with the key.`,
      );
      return;
    }

    const finalKey = discriminator ? `${key.name}@${discriminator}` : key.name;

    if (
      StoreModel.MODEL_TYPES.has(finalKey) &&
      typeInstance !== StoreModel.getType(key.name, discriminator)
    ) {
      console.warn(
        `StoreModelType: Type for ${key.name} with discriminator ${discriminator} is already registered. This might lead to unexpected behavior.`,
      );
    }
    StoreModel.MODEL_TYPES.set(finalKey, type());
  };
}

export function StoreModelJsonType(
  type: () => new (...args: any[]) => any,
  discriminator?: string,
) {
  return function (target: any, key: any) {
    const typeInstance = type();
    if (!typeInstance) {
      console.warn(
        `StoreModelJsonType: Unable to determine type for ${key.name}. Type might not exist or is declared after the class with the key.`,
      );
      return;
    }

    const finalKey = discriminator ? `${key.name}@${discriminator}` : key.name;

    if (
      StoreModel.JSON_TYPES.has(finalKey) &&
      typeInstance !== StoreModel.getJsonType(key.name, discriminator)
    ) {
      console.warn(
        `StoreModelJsonType: Type for ${key.name} with discriminator ${discriminator} is already registered. This might lead to unexpected behavior.`,
      );
    }
    StoreModel.JSON_TYPES.set(finalKey, type());
  };
}

export class StoreModelDate extends Date {
  override toJSON(key?: any): string {
    if (UTILS.DATE.isDate(this)) {
      return UTILS.DATE.toLocalISOString(this)!;
    }
    return super.toJSON(key);
  }
}

export class StoreModel {
  $uid: number | undefined;
  $isDeleted: boolean | undefined = false;

  static MODEL_TYPES: Map<string, Function> = new Map();

  static JSON_TYPES: Map<string, Function> = new Map();

  static getType(field: string, discriminator?: string): Function | undefined {
    return (
      StoreModel.MODEL_TYPES.get(field) ||
      StoreModel.MODEL_TYPES.get(`${field}@${discriminator}`) ||
      undefined
    );
  }
  static getJsonType(
    field: string,
    discriminator?: string,
  ): Function | undefined {
    return (
      StoreModel.JSON_TYPES.get(field) ||
      StoreModel.JSON_TYPES.get(`${field}@${discriminator}`) ||
      undefined
    );
  }

  $onTransform?: Function;
  $toDTO?: () => any;

  constructor() {
    this.$uid = UTILS.GENERATE.nextuid;
  }
}
